
  import { CompanyModel, FundRaisingRound } from '@/services/api/models'
  import { computed, defineComponent, onBeforeMount, ref, watch } from 'vue'
  import { useStore } from 'vuex'
  import { Input, Button } from '@up.law/uplaw-ui'
  import { Field } from 'vee-validate'
  import { useAcl } from 'vue-simple-acl/src'

  export default defineComponent({
    components: { Input, Field, Button },
    setup() {
      const store = useStore()
      const search = ref('')

      const currentCompany = computed<CompanyModel>(
        () => store.getters['organizations/contextCompany']
      )

      const acl = useAcl()
      const canDo = computed(
        () =>
          acl.role('admin') ||
          (acl.permission('is-manager') &&
            acl.permission('write-fundRaisingRound'))
      )

      const fund = computed<FundRaisingRound | null>(
        () => store.getters['organizations/fundRaisingRound']
      )

      const getFunds = (search = '') => {
        store.dispatch('organizations/GET_FUND_RAISING_ROUNDS', {
          companyId: currentCompany.value.id,
          filter: { search }
        })
      }

      const funds = computed<FundRaisingRound[]>(
        () => store.getters['organizations/fundRaisingRounds']
      )

      const initForm = () => {
        store.commit('organizations/SET_FUND_RAISING_ROUND', null)
        store.dispatch('organizations/INIT_MODAL_FORM', {
          ...store.getters['organizations/form'],
          modalInit: true,
          initCurrentForm: true
        })
      }

      const handleSelect = (fundId: string) => {
        store.dispatch('organizations/GET_FUND_RAISING_ROUND', {
          companyId: currentCompany.value.id,
          id: fundId
        })
      }

      onBeforeMount(() => {
        getFunds()
      })

      watch(search, (text: string) => {
        getFunds(text)
      })

      return { canDo, fund, search, funds, initForm, handleSelect }
    }
  })
